/**
 * Gets a set of photos for display, optionally fetching them.
 * Despite the name, most of our widget types use this fetch type.
 * @param boolean fetch
 */
export function getPhotosForPhotowall(fetch) {
    return getPhotosCollectionWidgets({
        url: function() {
            return Routes.distillery_widgets_path();
        }
    }, fetch);
};

/**
 * Gets a set of photos for display, but only 40 per page.
 */
export function getPhotosForMosaic() {
    return getPhotosCollectionWidgets({
        url:  function() {
            return Routes.distillery_widgets_path();
        },
        per_page: 40
    });
};

function getPhotosCollectionWidgets(options, fetch) {
    options = options || {};
    const photosCollection = new Pixlee.Entities.PhotosWidgets([], options);
    if (fetch !== false) {
        photosCollection.goTo(1, {
            reset: true,
            timeout: 10000,
            error: failCallback
        });
    }
    return photosCollection;
};

/**
 * If we fail to fetch photos, we close the widget automatically.
 */
function failCallback(_collection, response) {
    //just in case, there's some weird responses sometimes we want to be 10000% sure this failed
    if (response.statusText !== 'notmodified' && response.statusText !== 'success') {
        var message = {
            name: 'pixlee:close:widget',
            type: 'action',
            source: 'widget',
            destination: 'parent',
            data: {}
        };
        top.postMessage(JSON.stringify(message), '*');
    }
}
